import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { Alert, DialogActions, DialogContentText, DialogTitle, FormHelperText } from '@mui/material';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState, store, useAppSelector } from 'src/store';
import { setSnackbarMessage } from 'src/store/snackbarMessage';
import DocManagementService from './service/DocManagementService';
import { setDocumentDetail } from 'src/store/documentDetail';

export interface ISubArtifactData {
  id: string;
  version: string;
}

export const SelectSubartifact = (props: any) => {
  const documentDetail: any = useSelector((state: AppState) => state.documentDetail);
  const { setOpenSubArtifact, versionNumber, setDocUploadComponent } = props;
  const subArtifactVersions = props.subArtifactVersions;
  const [subArtifactVersionValue, setSubArtifactVersionValue] = useState<ISubArtifactData>({ id: '', version: '' });
  const docService = new DocManagementService();
  const user: any = useAppSelector(state => state.user.user);
  const userName = `${user.firstName + ' ' + user.lastName}`;
  const selectedStudy = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Study);
  const selectedCountry = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Country);
  const selectedSite = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Site);
  const dispatch = useDispatch();
  const [disableSave, setDisableSave] = useState(false);
  let TmfLevel =
    (selectedStudy === '--' || selectedStudy === '') &&
    (selectedCountry === '--' || selectedCountry == '') &&
    (selectedSite === '--' || selectedSite === '')
      ? '--'
      : (selectedCountry === '--' || selectedCountry == '') && (selectedSite === '--' || selectedSite === '')
      ? 'Study'
      : selectedSite === '--' && selectedCountry != '--'
      ? 'Country'
      : 'Site';
  if (TmfLevel === '--') {
    TmfLevel = 'Study';
  }
  const updatedVersionData = async (docData: any, docDetails: any) => {
    let qcResponse;
    if (docDetails.tmf_doc_status === 'Approved') {
      qcResponse = await getQcDetails(docDetails);
    }

    const params = {
      module_section_related: 'DocumentDetails',
      parent_entity_related: props.metaData.tmf_document_name
    };

    const res = await docService.updatedVersionData(params, docData);
    if (res.data) {
      setDocumentDetail(dispatch, [
        {
          ...documentDetail.data[0],
          fileId: res.data.file_master_id,
          tmf_doc_version_number: docData.tmf_doc_new_version_number,
          tmf_doc_status: res.data.document_data.tmf_doc_status,
          tmf_doc_viewer_req_certified_copy: res.data.tmf_doc_viewer_req_certified_copy,
          is_checkbox_verified: qcResponse?.data?.is_checkbox_verified
        }
      ]);
      store.dispatch(setSnackbarMessage('Document is updated successfully.', 'success'));
      props.handleCloseVersion();
    } else {
      store.dispatch(setSnackbarMessage('Error in updating document.', 'error'));
    }
    handleClose();
  };

  const overwriteVersionData = async (overwriteDocData: any, docDetails: any) => {
    let qcResponse;
    if (docDetails.tmf_doc_status === 'Approved') {
      qcResponse = await getQcDetails(docDetails);
    }
    const params = {
      module_section_related: 'DocumentDetails',
      parent_entity_related: props.metaData.tmf_document_name
    };
    const res = await docService.updateMasterDocument(params, overwriteDocData);
    if (res.data) {
      setDocumentDetail(dispatch, [
        {
          ...documentDetail.data[0],
          fileId: res.data.file_master_id,
          tmf_doc_status: res.data.document_data.tmf_doc_status,
          tmf_doc_viewer_req_certified_copy: res.data.tmf_doc_viewer_req_certified_copy,
          is_checkbox_verified: qcResponse?.data?.is_checkbox_verified
        }
      ]);
      store.dispatch(setSnackbarMessage('Document is updated successfully.', 'success'));
      props.handleCloseVersion();
    } else {
      store.dispatch(setSnackbarMessage('Error in updating document.', 'error'));
    }
    handleClose();
  };

  const getQcDetails = async (docDetails: any) => {
    const qcParams = {
      module_section_related: 'DocumentQCControl',
      parent_entity_related: docDetails.tmf_document_name
    };
    const result: any = await docService.getQualityControlDetailsById(
      docDetails.id,
      selectedStudy,
      selectedCountry,
      selectedSite,
      docDetails.tmf_doc_level,
      qcParams
    );
    const qualityControl = result?.data?.quality_control;
    const UpdatedQCData: any = {
      tmf_doc_viewer_req_certified_copy: 'N',
      tmf_doc_viewer_qc_issue_type: qualityControl?.tmf_doc_viewer_qc_issue_type,
      tmf_doc_viewer_qc_issue_comments: qualityControl?.tmf_doc_viewer_qc_issue_comments,
      id: qualityControl?.id,
      is_checkbox_verified: false,
      updated_by: userName
    };
    const qcResponse = await docService.updateQC(
      qcParams,
      UpdatedQCData,
      TmfLevel,
      selectedStudy,
      selectedCountry,
      selectedSite
    );
    return qcResponse;
  };

  const handleSaveUpdatedSubArtifact = async () => {
    setDisableSave(true);
    if (subArtifactVersionValue.id !== '') {
      const filterSubartifactId: any = subArtifactVersions.filter(
        (sub: any) => sub.tmf_document_id === subArtifactVersionValue.id
      );
      const params = {
        module_section_related: 'DocumentDetails',
        parent_entity_related: props.metaData.tmf_document_name
      };
      const docDetails: any = await docService.getMasterDocumentdetails(
        filterSubartifactId[0].tmf_doc_study,
        subArtifactVersionValue.id,
        filterSubartifactId[0].tmf_doc_version_number,
        props.metaData.tmf_doc_country ? props.metaData.tmf_doc_country : '--',
        props.metaData.tmf_doc_site ? props.metaData.tmf_doc_site : '--',
        props.metaData.tmf_doc_level ? props.metaData.tmf_doc_level : 'None',
        params
      );
      const docStatus =
        docDetails.data.document_data.tmf_doc_status === 'Approved'
          ? 'Uploaded'
          : docDetails.data.document_data.tmf_doc_status;

      const certifiedCopy =
        docDetails.data.document_data.tmf_doc_status === 'Approved'
          ? 'N'
          : docDetails.data.document_data.tmf_doc_viewer_req_certified_copy;

      const subartifactUpdateObj = {
        file_master_id: props.resData.id,
        document_data: {
          tmf_artifact_number: docDetails.data.document_data.tmf_artifact_number,
          tmf_document_name: props.metaData.tmf_document_name,
          tmf_doc_type: docDetails.data.document_data.tmf_doc_type,
          tmf_doc_subtype: docDetails.data.document_data.tmf_doc_subtype,
          tmf_doc_viewer_req_certified_copy: certifiedCopy,
          tmf_doc_status: docStatus,
          tmf_doc_country: docDetails.data.document_data.tmf_doc_country,
          tmf_doc_study: docDetails.data.document_data.tmf_doc_study,
          tmf_doc_site: docDetails.data.document_data.tmf_doc_site,
          tmf_doc_viewer_department: docDetails.data.document_data.tmf_doc_viewer_department,
          tmf_doc_viewer_language: docDetails.data.document_data.tmf_doc_viewer_language,
          tmf_doc_viewer_approval_cycle: docDetails.data.document_data.tmf_doc_viewer_approval_cycle,
          tmf_doc_viewer_product_detail: docDetails.data.document_data.tmf_doc_viewer_product_detail,
          tmf_doc_viewer_ref_model_version: docDetails.data.document_data.tmf_doc_viewer_ref_model_version,
          tmf_doc_viewer_format: docDetails.data.document_data.tmf_doc_viewer_format,
          tmf_doc_viewer_inspection_ready: docDetails.data.document_data.tmf_doc_viewer_inspection_ready,
          tmf_doc_viewer_ir_issue_type: docDetails.data.document_data.tmf_doc_viewer_ir_issue_type,
          tmf_doc_level: docDetails.data.document_data.tmf_doc_level,
          tmf_artifact_name: docDetails.data.document_data.tmf_artifact_name,
          tmf_doc_version_number: subArtifactVersionValue.version,
          tmf_doc_milestone: docDetails.data.document_data.tmf_doc_milestone,
          tmf_document_id: subArtifactVersionValue.id,
          id: docDetails.data.document_data.id,
          tmf_doc_last_modified_by: userName
        }
      };
      versionNumber === 'Major' || versionNumber === 'Minor'
        ? updatedVersionData(
            { ...subartifactUpdateObj, tmf_doc_new_version_number: subArtifactVersionValue.version },
            docDetails.data.document_data
          )
        : overwriteVersionData(subartifactUpdateObj, docDetails.data.document_data);
      props.setStyleUpload('uploadFile');
      props.setFileUploaded(null);
      props.setUploaded(false);
      props.ClearData();
      setDocUploadComponent(true);
    }
  };

  const handleBackDialogSubArtifact = () => {
    setOpenSubArtifact(false);
  };

  const handleCloseDialogSubArtifact = () => {
    setOpenSubArtifact(false);
    props.handleCloseVersion();
    props.documentValue();
    props.setStyleUpload('uploadFile');
    props.setFileUploaded(null);
    props.setUploaded(false);
    props.ClearData();
  };

  const dailogTitle = (versionNumber: string) => {
    if (versionNumber === 'Major') {
      return ' Select Subartifact to Update as Major Change';
    }
    if (versionNumber === 'Minor') {
      return ' Select Subartifact to Update as Minor Change';
    }
    if (versionNumber === 'Overwrite') {
      return ' Select Subartifact to Overwrite';
    }
  };

  const handleRadioValue = (e: any, value: any) => {
    setSubArtifactVersionValue({ id: value, version: e.target.name });
  };

  const handleClose = () => {
    props.setOpenVersion(false);
  };

  return (
    <div className="versionControl-modal">
      <React.Fragment>
        <DialogTitle>{dailogTitle(versionNumber)}</DialogTitle>
        <DialogContent className="selectSubArtifact-modalcontent">
          {versionNumber === 'Overwrite' && (
            <Alert severity="info">Overwriting will replace the current document</Alert>
          )}
          <DialogContentText>
            <dl>
              <dt>Artifact:</dt>
              <dd>{subArtifactVersions[0].tmf_artifact_name}</dd>
            </dl>
            <dl>
              <dt>Subartifacts Uploaded:</dt>
            </dl>
          </DialogContentText>
          <FormControl className="special-radiobtn-group">
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue={subArtifactVersionValue.id}
              name="radio-buttons-group"
              onChange={handleRadioValue}
            >
              {subArtifactVersions.map((el: any) => {
                if (versionNumber === 'Major' || versionNumber === 'Minor') {
                  return (
                    <div key={el.tmf_document_id}>
                      <FormControlLabel
                        value={el.tmf_document_id}
                        control={<Radio />}
                        label={el.tmf_document_name}
                        name={
                          versionNumber === 'Major'
                            ? Math.floor(el.tmf_doc_version_number + 1.0).toFixed(1)
                            : (el.tmf_doc_version_number + 0.1).toFixed(1)
                        }
                        labelPlacement="start"
                        sx={{
                          '& .MuiSvgIcon-root': {
                            fontSize: 24
                          }
                        }}
                        disabled={disableSave}
                      />
                      <FormHelperText>
                        Current:&nbsp;<span>Version {el.tmf_doc_version_number.toFixed(1)}</span> <ArrowRightAltIcon />{' '}
                        After Update:{' '}
                        <span>
                          &nbsp;
                          {versionNumber === 'Major'
                            ? Math.floor(el.tmf_doc_version_number + 1.0).toFixed(1)
                            : (el.tmf_doc_version_number + 0.1).toFixed(1)}
                        </span>
                      </FormHelperText>
                    </div>
                  );
                } else {
                  return (
                    <div key={el.tmf_document_id}>
                      <FormControlLabel
                        value={el.tmf_document_id}
                        control={<Radio />}
                        label={el.tmf_document_name}
                        name={el.tmf_doc_version_number.toFixed(1)}
                        labelPlacement="start"
                        sx={{
                          '& .MuiSvgIcon-root': {
                            fontSize: 24
                          }
                        }}
                        disabled={disableSave}
                      />
                      <FormHelperText>
                        Overwrite current version: &nbsp; <span> {el.tmf_doc_version_number.toFixed(1)}</span>
                      </FormHelperText>
                    </div>
                  );
                }
              })}
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'space-between' }}>
          <div>
            <Button onClick={handleBackDialogSubArtifact} className="grey-btn" disabled={disableSave}>
              Back
            </Button>
          </div>
          <div>
            <Button onClick={handleCloseDialogSubArtifact} className="grey-btn" disabled={disableSave}>
              Close
            </Button>
            <Button onClick={handleSaveUpdatedSubArtifact} disabled={disableSave || !subArtifactVersionValue?.id}>
              Save
            </Button>
          </div>
        </DialogActions>
      </React.Fragment>
    </div>
  );
};
